/**
 * Radius tokens — one scale for controls, cards, and modals.
 */
export const radii = {
  control: 'rounded-lg',
  controlMd: 'rounded-xl',
  card: 'rounded-2xl',
  cardResponsive: 'rounded-xl md:rounded-2xl',
  cardLg: 'rounded-[2rem]',
  empty: 'rounded-3xl',
  modal: 'rounded-[2rem]',
  modalTop: 'rounded-t-[2rem]',
  modalPanel: 'rounded-t-[2rem] sm:rounded-[2rem]',
  pill: 'rounded-full',
};
